module.exports = __webpack_public_path__ + "static/media/rate-call.07a88d8b.svg";